import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { API_BASE_URL } from '../config/config';
import './Noticia.css';

const Noticia = () => {
  const { id } = useParams();
  const [noticia, setNoticia] = useState(null);

  // Scroll al principio al montar
  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => window.scrollTo(0, 0), 100); // refuerzo si carga lento
  }, []);

  useEffect(() => {
    if (!id || id === "undefined") {
      console.error("El parámetro 'id' es undefined. Verifica la configuración de la ruta o el enlace utilizado.");
      return;
    }

    const fetchNoticia = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/noticias/${id}`);
        if (!res.ok) {
          console.error("Error en respuesta del servidor:", res.statusText);
          return;
        }
        const data = await res.json();
        setNoticia(data);
      } catch (error) {
        console.error('Error al obtener la noticia:', error);
      }
    };

    fetchNoticia();
  }, [id]);

  if (!noticia) {
    return <div className="noticia-detalle-container">Cargando noticia...</div>;
  }

  const construirImagenUrl = (imagenPath) => {
    if (!imagenPath) return null;
    // Si ya es una URL completa (Cloudinary), retornarla tal cual
    if (imagenPath.startsWith('http')) return imagenPath;
    // Si es una ruta relativa local, construir la URL completa
    const STATIC_BASE_URL = API_BASE_URL.replace('/api', '');
    if (imagenPath.startsWith('/uploads')) return `${STATIC_BASE_URL}${imagenPath}`;
    // Fallback
    return imagenPath;
  };

  const imagenUrl = construirImagenUrl(noticia.imagenPath);

  return (
    <div className="noticia-detalle-container">
      <h1 className="noticia-detalle-titulo">{noticia.titulo}</h1>
      {imagenUrl && (
        <img
          className="noticia-detalle-imagen"
          src={imagenUrl}
          alt={`Imagen de ${noticia.titulo}`}
          onError={(e) => {
            console.error('Error cargando imagen:', imagenUrl);
            e.target.style.display = 'none';
          }}
        />
      )}
      <div className="noticia-detalle-contenido">
        {noticia.contenido.split('\n').map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    </div>
  );
};

export default Noticia;
